import React, { FC } from 'react'
import { H5 } from '@blueprintjs/core'
import cx from 'classnames'
import { Flex, GridTableStatusEnum, Icon, IGridTableColumn, NewGridTable } from '@ui'
import MappingSelect, { MAPPING_VALUE } from './MappingSelect'
import track from '@track'
import Event from '@track/Event'
import { Mapping } from './hooks/useImportMappings'
import css from './importFlow.module.scss'

interface IMappingStepProps {
  mappingChecklist: Array<{ children: string; pass: boolean }>
  mappings: Mapping[]
  setMappings: (mappings: Mapping[]) => void
}

export default function MappingStep({
  mappingChecklist,
  mappings,
  setMappings,
}: IMappingStepProps) {
  const columns: IGridTableColumn<Mapping>[] = [
    {
      label: 'From source field',
      Cell: ({ cell }) => {
        if (!cell) return null
        return <div>{cell.data.csv}</div>
      },
    },
    {
      label: '',
      Cell: ({ cell }) => {
        if (!cell) return null

        return <div>{cell.data.csv && cell.data.siq && <Icon name="long-arrow-right" />}</div>
      },
    },
    {
      label: 'To SpaceIQ field',
      Cell: ({ cell }) => {
        if (!cell) return null

        return (
          <div className={css.cell}>
            <Flex style={{ height: 24 }}>
              <MappingSelect
                buttonProps={{ small: true }}
                value={cell.data.siq as MAPPING_VALUE}
                onChange={(value) => {
                  setMappings(
                    mappings.map((m) => {
                      return m.id === cell.data.id
                        ? { ...m, siq: value }
                        : {
                            ...m,
                            siq:
                              m.siq === value &&
                              !(value === 'Create Extra Field' || value === 'false')
                                ? null
                                : m.siq,
                          }
                    })
                  )

                  track.employeeImportDialog({
                    eventName: Event.FILTER,
                    props: {
                      filterName: 'mapping',
                      filterValue: value,
                    },
                  })
                }}
              />
            </Flex>
          </div>
        )
      },
    },
  ]

  const format = (items: Mapping[]) => {
    return items.map((i) => ({
      data: i,
    }))
  }

  const formated = format(mappings)

  return (
    <div>
      <H5>Map Employee Profile</H5>
      <p>
        For each of the source data fields below, select the corresponding SpaceIQ data field name.
        Your mapping will be saved for future imports.
      </p>
      <div className={css.checklist_container}>
        <p style={{ fontSize: 12, color: 'var(--grey1)' }}>Required mappings</p>
        <div className={css.checklist}>
          {mappingChecklist.map((item, i) => (
            <ChecklistItem key={i} {...item} />
          ))}
        </div>
      </div>
      <div className={css.table_wrapper}>
        <NewGridTable<Mapping>
          sticky={false}
          status={!mappings.length ? GridTableStatusEnum.IDLE : GridTableStatusEnum.IDLE}
          columns={columns}
          data={formated}
        />
      </div>
    </div>
  )
}

type ChecklistItemPropsT = React.DetailedHTMLProps<
  React.LiHTMLAttributes<HTMLLIElement>,
  HTMLLIElement
> & { pass: boolean }

const ChecklistItem: FC<React.PropsWithChildren<ChecklistItemPropsT>> = ({
  pass,
  className,
  ...props
}) => {
  return (
    <li
      className={cx(css.checklist_container, className, {
        [css.pass]: pass,
      })}
      {...props}
    />
  )
}
